import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Philosophy from "./components/Philosophy";
import Services from "./components/Services";
import HabitPlan from "./components/HabitPlan";
import Founder from "./components/Founder";
import Conditions from "./components/Conditions";
import Process from "./components/Process";
import Testimonials from "./components/Testimonials";
import BeforeAfter from "./components/BeforeAfter";
import FAQ from "./components/FAQ";
import Booking from "./components/Booking";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import SmoothScroll from "./components/SmoothScroll";
import Marquee from "./components/Marquee";

import { AuthProvider } from "./contexts/AuthContext";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import DietPlanBuilder from "./pages/DietPlanBuilder";
import { installGtag, trackPageView } from "./lib/analytics";

const Landing = () => {
  return (
    <main className="relative" data-testid="landing-root">
      <SmoothScroll />
      <Header />
      <Hero />
      <About />
      <Philosophy />
      <Services />
      <Marquee />
      <HabitPlan />
      <Founder />
      <Conditions />
      <Process />
      <Testimonials />
      <BeforeAfter />
      <FAQ />
      <Booking />
      <Footer />
      <FloatingWhatsApp />
    </main>
  );
};

function App() {
  useEffect(() => {
    installGtag();
    trackPageView();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/leads" element={<AdminDashboard />} />
            <Route path="/admin/diet-plans" element={<DietPlanBuilder />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "rgba(20, 3, 38, 0.85)",
            color: "#F5F3FF",
            border: "1px solid rgba(180, 141, 255, 0.3)",
            backdropFilter: "blur(16px)",
          },
        }}
      />
    </div>
  );
}

export default App;
